// 德语
const de = {
    next: 'Weiter',
    error: 'Fehler',
    notFound: '404 Nicht gefunden.',
    m: {
        loginTitle: "Entsperren Sie Ihre Powerbank",
        phonePlaceholder: "Handynummer",
        or: 'oder',
        emailLogin: 'Weiter mit E-Mail',
        phoneLogin: 'Weiter mit Telefon',
        quickLogin: 'Als Gast fortfahren',
        loginRequiredTip: 'Bitte melden Sie sich zuerst an',
        continueGoogle: "Mit Google fortfahren",
        continueApple: "Mit Apple fortfahren",
        langBoxTitle: "Sprache wählen",
        policyAndTerms: "Zustimmen zu [brandName]'s <a href='[termsOfServiceUrl]'>Nutzungsbedingungen</a> und <a href='[privacyPolicyUrl]'>Datenschutzrichtlinie</a>.",
        verifyTitle: 'Geben Sie den 6-stelligen Code ein, der Ihnen an [phonenumber] gesendet wurde',
        verifyEmailTitle: 'Geben Sie den 6-stelligen Code ein, der Ihnen an [email] gesendet wurde',
        paymentTitle: 'Entsperren Sie Ihre Powerbank',
        resend: "Code erneut senden",
        emailAddress: "E-Mail-Adresse",
        registerTitle: 'Geben Sie Ihre Informationen ein.',
        fNameInput: 'Vorname',
        lNameInput: 'Nachname',
        emailInput: 'E-Mail-Adresse',
        birthInput: 'Geburtsdatum',
        postCodeInput: 'Postleitzahl',
        billingRate: 'Rate',
        unpaidPopupSubtitle: "Sie haben eine unbezahlte Bestellung",
        unpaidPopupContent: "Sie haben eine unbezahlte Bestellung. Bitte begleichen Sie die Zahlung, bevor Sie erneut mieten.",
        payNow: "Jetzt bezahlen",
        add: "Hinzufügen",
        minBalanceTag: 'Min.: {amount}',
        paymentSuccessfulSubtitle: "Zahlung erfolgreich!",
        paymentSuccessfulContent: "Sie können Ihre Miete jetzt fortsetzen!",
        goToRental: "Zur Miete gehen",
        repaymentTitle: "Bestellzahlung",
        rentalInformation: "Mietinformationen",
        selectPayMethod: 'Zahlungsmethode wählen',
        selectAuthorizationMethod: 'Autorisierungsmethode wählen',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Guthaben',
        creditOrDebit: 'Karte',
        free: 'Kostenlos',
        pay: 'Bezahlen',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        unlockNow: 'Powerbank entsperren',
        savePay: 'Speichern & Bezahlen',
        saveRent: 'Mieten',
        recharge: 'Aufladen',
        balancePopupTitle: 'Aufladen',
        balancePopupCurrentBalance: 'Aktuelles Guthaben: {amount}',
        balancePopupMinRentBalance: 'Mindestguthaben zum Mieten: {amount}',
        topUpRent: 'Aufladen',
        topUpSaveCard: 'Aufladen',
        bindPopupTitle: 'Zahlungskarte hinzufügen',
        cardPaymentTitle: 'Kartenzahlung',
        preparingTitle: 'Ladegerät wird vorbereitet',
        preparingSubtitle: 'Ihre Powerbank wird ausgegeben. Bitte warten Sie geduldig.',
        preparingStationBusySubtitle: 'Wir warten, bis die vorherige Powerbank ausgegeben wurde. Bitte warten Sie.',
        rentalSuccessTitle: 'Erfolg!',
        rentalFailTitle: 'Fehlschlag!',
        rentalSuccessSubtitle: 'Vielen Dank für die Nutzung von [brandName]. Bitte geben Sie die Powerbank nach Gebrauch zurück.',
        rentalNumber: 'Mietnummer',
        rentalTime: 'Mietzeit',
        rentalLocation: 'Mietort',
        returnTime: "Rückgabezeit",
        returnLocation: "Rückgabeort",
        rentalDuration: "Mietdauer",
        totalAmount: "Gesamtbetrag",
        paidAmount: "Bezahlt Betrag",
        unpaidAmount: "Fälliger Betrag",
        currentFee: "Aktuelle Gebühr",
        rentalInfo: 'Mietinformationen',
        rentingTitle: 'Sie verwenden derzeit eine [brandName] Powerbank',
        keepIt: 'Möchten Sie sie behalten? Jetzt kaufen!',
        findNearby: 'Finden Sie ganz einfach Rückgabestationen in Ihrer Nähe – laden Sie jetzt unsere App herunter!',
        nearbyStationTitle: 'Stationen in der Nähe',
        nearbyStationSearchPlaceholder: 'Nach Ladestationen in der Nähe suchen',
        nearbyStationRent: 'Mieten',
        nearbyStationReturn: 'Zurückgeben',
        nearbyStationAvailable: 'Verfügbar',
        nearbyStationEmpty: 'Leer',
        nearbyStationLoading: 'Stationen in der Nähe werden geladen...',
        nearbyStationNoStations: 'Keine Stationen in der Nähe',
        nearbyStationNoRentStations: 'Keine mietbaren Stationen in der Nähe',
        nearbyStationNoReturnStations: 'Keine Rückgabestationen in der Nähe',
        nearbyStationSearchAria: 'Stationen in der Nähe suchen',
        nearbyStationType: 'Stationstyp',
        nearbyStationDistance: 'Entfernung',
        scanForPowerbank: 'Powerbank scannen',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Rückgabe-Maschinen',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'Andere Maschinen in der Nähe ansehen',
        viewNearbyReturnLocations: 'Rückgabe-Maschinen',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'Diese Maschine ist bereit',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Finde eine verfügbare Maschine in der Nähe und scanne ihren Code.',
        mapIslandMachineUnavailableShort: 'Diese Maschine ist nicht verfügbar',
        mapIslandMachineAvailableActionShort: 'Mit dieser Maschine fortfahren',
        mapIslandMachineUnavailableActionShort: 'Andere Maschine scannen',
        mapIslandReturnActionShort: 'Zur Miete zurück',
        rentingMapIslandTitle: 'Miete läuft',
        tapToReturnRentalPage: 'Zur Miete zurückkehren.',
        scan: 'Scannen',
        scannerHint: 'QR-Code an der Ladestation finden',
        flashlight: 'Taschenlampe',
        mapBack: 'Zurück',
        currentLocation: 'Aktueller Standort',
        backToMap: 'Zurück zur Karte',
        mapMenu: 'Menü',
        mapMenuYourInfo: 'Ihre Daten',
        mapMenuLanguage: 'Sprache',
        mapMenuHelp: 'Hilfe',
        helpTitle: 'Hilfe',
        helpReportProblem: 'Problem melden',
        helpChatWithUs: 'Chatten Sie mit uns',
        chatWithUsTitle: 'Chatten Sie mit uns',
        chatContactMethods: 'Kontaktmöglichkeiten',
        reportProblemTitle: 'Problem melden',
        reportDeviceCode: 'Gerätecode',
        reportScanQrCode: 'Maschinen-QR-Code scannen',
        reportDeviceCodePlaceholder: 'Maschinen-QR scannen oder Geräte-ID eingeben',
        reportProblemType: 'Problem',
        reportProblemTypeAria: 'Problemtyp',
        reportProblemPowerBankNotEjected: 'Powerbank nicht ausgegeben',
        reportProblemCannotChargeDevice: 'Gerät lädt nicht',
        reportProblemOrderNotEnded: 'Bestellung nicht beendet',
        reportProblemCableDamagedLost: 'Kabel beschädigt/verloren',
        reportProblemOther: 'Sonstiges',
        reportTakePicture: 'Bild hochladen',
        reportChooseOrTakePicture: 'Bild hochladen',
        reportRemovePicture: 'Foto entfernen',
        reportDescribeProblem: 'Problem beschreiben',
        reportDescriptionPlaceholder: 'Bitte geben Sie eine Beschreibung ein',
        reportFieldRequired: 'Erforderlich',
        reportFieldOptional: 'Optional',
        reportSubmit: 'Senden',
        reportSubmittedSuccessfully: 'Erfolgreich gesendet',
        mapMenuLogin: 'Anmelden',
        mapMenuLogout: 'Abmelden',
        mapMenuLogoutSuccess: 'Abgemeldet',
        mapMenuLoadingProfile: 'Profil wird geladen...',
        mapMenuLogoutConfirmTitle: 'Abmelden?',
        mapMenuLogoutConfirmContent: 'Sie müssen sich erneut anmelden, bevor Sie wieder mieten können.',
        profileTitle: 'Profil',
        profileSave: 'Speichern',
        profileNoChanges: 'Bitte aktualisieren Sie mindestens ein Feld mit einem Wert.',
        profileDeleteAccount: 'Löschen',
        profileDeleteConfirmTitle: 'Konto löschen?',
        profileDeleteConfirmContent: 'Alle Daten in Ihrem Konto werden dauerhaft gelöscht und Sie werden danach abgemeldet.',
        closeScanner: 'Scanner schließen',
        directions: 'Route',
        call: 'Anrufen',
        cabinet: 'Station',
        addressUnavailable: 'Adresse nicht verfügbar',
        open: 'Geöffnet',
        closed: 'Geschlossen',
        opens: 'Öffnet',
        closes: 'Schließt',
        hoursUnavailable: 'Öffnungszeiten nicht verfügbar',
        mapUnavailable: 'Karte nicht verfügbar',
        googleMapsKeyNotConfigured: 'Google Maps-Schlüssel ist nicht konfiguriert',
        googleMapsLoadFailed: 'Google Maps konnte nicht geladen werden',
        retry: 'Erneut versuchen',
        mapLoading: 'Karte wird geladen...',
        mapReloading: 'Karte wird neu geladen...',
        cameraUnavailable: 'Kamera ist in diesem Browser nicht verfügbar',
        cameraPermissionDenied: 'Kamerazugriff wurde verweigert',
        cameraStartFailed: 'Kamera konnte nicht gestartet werden',
        flashlightUnsupported: 'Taschenlampe wird auf diesem Gerät nicht unterstützt',
        flashlightSwitchFailed: 'Taschenlampe konnte nicht umgeschaltet werden',
        invalidQrCode: 'Ungültiges QR-Code-Format',
        noon: 'Mittag',
        weekdayMonday: 'Montag',
        weekdayTuesday: 'Dienstag',
        weekdayWednesday: 'Mittwoch',
        weekdayThursday: 'Donnerstag',
        weekdayFriday: 'Freitag',
        weekdaySaturday: 'Samstag',
        weekdaySunday: 'Sonntag',
        weekdayMon: 'Mo',
        weekdayTue: 'Di',
        weekdayWed: 'Mi',
        weekdayThu: 'Do',
        weekdayFri: 'Fr',
        weekdaySat: 'Sa',
        weekdaySun: 'So',
        orderDeatil: 'Bestelldetails',


        subsTitle: 'Plan auswählen',
        default: 'Standard',
        subscribeAndSave: 'Abonnement & Sparen',
        autoRenew: 'Automatische Verlängerung',
        reachLimit: 'Nutzungslimit erreicht',
        paymentAuthorizationTitle: 'Zahlungsautorisierung',
        paymentAuthorizationRequired: 'Zahlungsautorisierung erforderlich',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'Eine Autorisierung ist erforderlich, wenn die Miete Ihren Tarif überschreiten könnte oder wenn keine Zahlungsmethode für mögliche Zusatzkosten hinterlegt ist.',
        paymentAuthorizationDesc3: 'Es wird eine vorübergehende Reservierung von [amount] vorgenommen. Falls keine Zusatzkosten anfallen, wird der Betrag nach der Rückgabe vollständig freigegeben; andernfalls wird der verbleibende Betrag nach Abzug etwaiger Zusatzkosten erstattet.',
        paymentAuthorizationDesc4: 'Bitte wählen Sie unten eine der Autorisierungsmethoden für diese Miete aus.',

        totalCost: 'Gesamtkosten',
        returnSuccessTitle: 'Erfolgreich zurückgegeben!',
        returnSuccessSubtitle: 'Vielen Dank für die Nutzung von [brandName].',
        rentAgain: 'Erneut mieten',
        guestLoginTips: 'Diese Funktion erfordert ein formelles Konto. Der Gastmodus ist nicht verfügbar. Möchten Sie sich anmelden?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    tMsg: {
        agreePolicy: '[brandName]’s Privacy Poilicy und Terms & Conditions zustimmen',
        errorTel: 'Bitte geben Sie eine korrekte Telefonnummer ein',
        sendSuccess: 'Erfolgreich versendet',
        inputAll: 'Bitte geben Sie alle benötigten Informationen ein',
        wrongEmail: 'Falsches Email-Format',
        wrongBirthday: 'Bitte geben Sie Ihr Geburtsdatum im korrekten Format ein',
        initPayFail: 'Initialbezahlung fehlgeschlagen',
        bindTimeout: 'Zeitüberschreitung beim Kartenbinden, bitte versuchen Sie es erneut',
        bindSuccess: 'Karte erfolgreich gebunden',
        subscriptionSuccess: 'Abonnement erfolgreich gekauft',
        bindFailed: 'Kartenbindung fehlgeschlagen',
        paymentFailed: 'Zahlung fehlgeschlagen',
        loginError: 'Anmeldefehler',
        paymentMethodNotSupported: 'Zahlungsmethode nicht unterstützt',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] Minuten',
        freeTimeDesc: 'Kostenlose [free_time] Minuten',
        flatFeeDesc: '[flat_fee] Pauschalgebühr für die ersten [flat_fee_time] Minuten',
        lowLimitDesc: 'Mindestgebühr: [low_limit]',
        topLimitDesc: 'Maximale Tagesgebühr: [top_limit]',
        preAuthDesc: '[pre_auth_amount] wird auf Ihrem Zahlungsmittel vorgemerkt',
        depositDesc: 'Wenn nicht innerhalb von [maximum_rental_time] Stunden zurückgegeben, wird [deposit] berechnet und die Powerbank gehört Ihnen',
        ruleError: 'Regelfehler',
        noneRuleDesc: 'Keine Regeln',
        taxIncluded: 'Inklusive Steuern',
        taxIncludedWithRate: 'Inklusive [tax]% Steuer'
    },
    subscriptionType: {
        1: 'Kostenlos [value] Minuten pro Abonnementzeitraum',
        2: 'Kostenlos [value] Minuten pro Monat',
        3: 'Kostenlos [value] Minuten pro Woche',
        4: 'Kostenlos [value] Minuten pro Tag',
        6: 'Kostenlos [value] Mal pro Abonnementzeitraum',
        7: 'Kostenlos [value] Mal pro Monat',
        8: 'Kostenlos [value] Mal pro Woche',
        9: 'Kostenlos [value] Mal pro Tag',
        unlimited: 'unbegrenzt',
        unlimitedRentals: 'Kostenlose unbegrenzte Anmietungen pro Abonnementzeitraum',
        durationLimit: 'Bis zu [limit] Minuten kostenlose Anmietung pro Anmietung. Danach [price] pro [price_time] Minuten',
        maxLimit: ', maximal [top_limit] pro Tag',
    },
    subscriptionTitleType: {
        1: '[value] Minuten pro Abonnementzeitraum',
        2: '[value] Minuten pro Monat',
        3: '[value] Minuten pro Woche',
        4: '[value] Minuten pro Tag',
        6: '[value] Mal pro Abonnementzeitraum',
        7: '[value] Mal pro Monat',
        8: '[value] Mal pro Woche',
        9: '[value] Mal pro Tag',
        unlimited: 'Unbegrenzt',
        unlimitedRentals: 'Unbegrenzte Anmietungen pro Abonnementzeitraum',
    },
    subscriptionInfo: {
        period: 'Zeitraum: [start] - [end]',
        usedShort: '([used]/[total] verwendet)',
        usage: 'Nutzung: [total] gesamt, [used] verwendet, [remaining] verbleibend',
        usageUnlimited: 'Nutzung: unbegrenzt',
        autoRenew: 'Automatische Verlängerung: [value]',
        autoRenewTrue: 'Ja',
        autoRenewFalse: 'Nein',
    },
    time: {
        day: 'Tag | Tage',
        hour: 'Stunde | Stunden',
        minute: 'Minute | Minuten',
        second: 'Sekunde | Sekunden',
        month: 'Monat | Monate',
        year: 'Jahr | Jahre'
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "Netzwerkfehler",
        1000: "Vorgang fehlgeschlagen",
        30022: "Bitte geben Sie Ihre Telefonnummer im korrekten Format ein",
        30128: "Verifizierungscode zu oft gesendet. Bitte versuchen Sie es später erneut.",
        30129: "Senden des Verifizierungscodes fehlgeschlagen",
        30101: 'Verifizierungscode ist inkorrekt oder nicht mehr gültig',
        // 租借
        50101: "Station nicht gefunden",
        50105: "Sie haben eine ausstehende Bestellung",
        50106: "Station ist derzeit offline",
        50108: "Derzeit gibt es keine verfügbaren Powerbanks",
        50109: "Powerbankausgabe fehlgeschlagen. Bitte versuchen Sie es später erneut.",
        50113: 'Diese Station erfordert ein Konto',
        50114: 'Gäste können diese Funktion nicht nutzen. Bitte anmelden',
        50111: 'Ungültige Zahlungsart',
        50305: 'Ungültige Zahlungsart',
        80411: 'Hinzufügen der Zahlungsart fehlgeschlagen',
        50103: 'Keine gültige Zahlungsart',
        50206: 'Die Bezahlung Ihrer letzten Bestellung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsart.',
    }
}
export default de
